import React from 'react';
import { BackgroundImage, Center, Container, Space } from '@mantine/core';


type HomePageProps = {
  id: string,
};


const WaterPage = ({ id }: HomePageProps) => {

  return (
    <Container sx={(theme) => ({
      marginTop: "0px",
      width: '100%',
    })}>
      <BackgroundImage src={"header-dark.jpg"}>
        <Container sx={(theme) => ({
          width: '100%',
          minHeight: '140px',
        })}>
          <Center style={{ height: 140, color: "white" }}>

            <h1>Kortedala vattendistribution</h1>

          </Center>
        </Container>
      </BackgroundImage>

      <Container sx={(theme) => ({ paddingLeft: theme.spacing.md })}>

      <p>
        Välkommen hit. Hemsidan för vattenföreningen i Egnahemsområdet i Kortedala – <i>Kortedala Vattendistribution.</i>
      </p>
      <p>
        Här kommer vi att lägga upp information som är relevant för er som är medlemmar i föreningen.
        Tips och praktiska råd varvat med föreningsinfo. I Kalendariet hittar du kommande möten och
        händelser som är bra att hålla koll på.
      </p>

        <Space h={"md"}/>

        <h3>Föreningsstämma (årsmöte)</h3>
        <p>
          Kortedala församling, Årstidsgatan 1<br/>
          10:e Maj kl 15:00<br/>
        </p>
        <p>
          <i>Mötesdokument</i><br/>
          <a href={"https://drive.google.com/drive/folders/1hWKmcAzUEW_-RqCK95cJNb-K8Tl-W1LA?usp=sharing"}>Dokument för 2026</a><br/>
        </p>

      </Container>
      <Space h={'xl'}/>


    </Container>
  );
}

export default WaterPage;
